// Standard operator list used across conditions builders (Data Filters, Live Rate Shipping Options, etc.)
// Keep this as the single source of truth.

export const STANDARD_OPERATORS = [
    '==',
    '!=',
    '<',
    '<=',
    '>',
    '>=',
    'Is Empty',
    'Is Not Empty',
    'Is True',
    'Is False',
    'In List',
    'Not In List',
    'Contains',
    'Not Contains',
    'Regex',
];

export const OPERATOR_DESCRIPTIONS = {
    '==': 'Checks if the field value exactly equals the specified value',
    '!=': 'Checks if the field value does not equal the specified value',
    '<': 'Checks if the field value is less than the specified value (numeric comparison)',
    '<=': 'Checks if the field value is less than or equal to the specified value',
    '>': 'Checks if the field value is greater than the specified value (numeric comparison)',
    '>=': 'Checks if the field value is greater than or equal to the specified value',
    'Is Empty': 'Checks if the field is empty, null, or undefined (value field not required)',
    'Is Not Empty': 'Checks if the field has a value (not empty, null, or undefined) (value field not required)',
    'Is True': 'Checks if the field value is boolean true or "true" string (value field not required)',
    'Is False': 'Checks if the field value is boolean false or "false" string (value field not required)',
    'In List': 'Checks if the field value matches any item in a comma-separated list (e.g., "value1,value2,value3")',
    'Not In List': 'Checks if the field value does not match any item in a comma-separated list',
    'Contains': 'Checks if the field value contains the specified substring (case-insensitive)',
    'Not Contains': 'Checks if the field value does not contain the specified substring (case-insensitive)',
    'Regex': 'Matches the field value against a regular expression pattern (uses PHP PCRE)',
};
